// ─────────────────────────────────────────────────────────────
//  SINGLE SOURCE OF TRUTH FOR ALL APPLICATION COLORS
//  Import from here everywhere — never define colors inline.
// ─────────────────────────────────────────────────────────────

// Neutral grey scale (Slate)
export const GREY = {
  0:   "#FFFFFF",
  100: "#F8FAFC",
  200: "#F1F5F9",
  300: "#E2E8F0",
  400: "#CBD5E1",
  500: "#94A3B8",
  600: "#64748B",
  700: "#475569",
  800: "#1E293B",
  900: "#0F172A",
};

// Primary — Teal
export const PRIMARY = {
  lighter:     "#CCFBF1",
  light:       "#2DD4BF",
  main:        "#0D9488",
  dark:        "#0F766E",
  darker:      "#134E4A",
  contrastText: "#fff",
};

// Secondary — Orange
export const SECONDARY = {
  lighter:     "#FFEDD5",
  light:       "#FB923C",
  main:        "#F97316",
  dark:        "#EA580C",
  darker:      "#7C2D12",
  contrastText: "#fff",
};

// Info — Sky Blue
export const INFO = {
  lighter:     "#F0F9FF",
  light:       "#7DD3FC",
  main:        "#38BDF8",
  dark:        "#0EA5E9",
  darker:      "#0369A1",
  contrastText: "#0F172A",
};

// Success — Green
export const SUCCESS = {
  lighter:     "#DCFCE7",
  light:       "#4ADE80",
  main:        "#22C55E",
  dark:        "#16A34A",
  darker:      "#14532D",
  contrastText: "#fff",
};

// Warning — Yellow
export const WARNING = {
  lighter:     "#FEF9C3",
  light:       "#FDE047",
  main:        "#EAB308",
  dark:        "#CA8A04",
  darker:      "#713F12",
  contrastText: "#1E293B",
};

// Error — Red
export const ERROR = {
  lighter:     "#FEE2E2",
  light:       "#FCA5A5",
  main:        "#EF4444",
  dark:        "#DC2626",
  darker:      "#7F1D1D",
  contrastText: "#fff",
};

// ─────────────────────────────────────────────────────────────
//  ROLE COLORS  (single source of truth)
// ─────────────────────────────────────────────────────────────

export const ROLE_COLORS: Record<string, string> = {
  superadmin: "#DC2626",   // Red
  admin:      "#0D9488",   // Teal — matches primary
  user:       "#F97316",   // Orange — matches secondary (agent)
  employee:   "#22C55E",   // Green — matches success
};

export const ROLE_LABELS: Record<string, string> = {
  superadmin: "Super Admin",
  admin:      "Admin",
  user:       "Agent",
  employee:   "Employee",
};

// ─────────────────────────────────────────────────────────────
//  TOAST COLORS
// ─────────────────────────────────────────────────────────────

export const TOAST = {
  bg:           "#1E293B",
  text:         "#F8FAFC",
  success:      "#22C55E",
  error:        "#EF4444",
  loading:      "#2DD4BF",
  borderRadius: "10px",
};
